var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-align-items-center is-justify-content-space-between mb-1",
                },
                [
                  _c("h1", { staticClass: "title" }, [_vm._v(" Devices ")]),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { type: "is-primary", "icon-left": "plus" },
                          on: { click: () => (_vm.addNewDevice = true) },
                        },
                        [_vm._v(" New device ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { type: "is-primary", "icon-left": "plus" },
                          on: { click: () => (_vm.batchAddNewDevice = true) },
                        },
                        [_vm._v(" Batch new device ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "is-danger",
                            "icon-left": "square-xmark",
                            disabled: _vm.checkedRows.length == 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteDevices()
                            },
                          },
                        },
                        [_vm._v(" Batch delete ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { "icon-left": "sync" },
                          on: { click: _vm.refreshButton },
                        },
                        [_vm._v(" Refresh ")]
                      ),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            label: "Export qrcode in pdf",
                            position: "is-bottom",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { "icon-left": "save" },
                              on: { click: _vm.exportInfo },
                            },
                            [_vm._v(" Export ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", [
                _c("div", { staticClass: "columns is-multiline" }, [
                  _c(
                    "div",
                    { staticClass: "column is-narrow" },
                    [
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Search" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  placeholder: "Search...",
                                  type: "search",
                                  icon: "search",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "By type" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.searchByType,
                                    callback: function ($$v) {
                                      _vm.searchByType = $$v
                                    },
                                    expression: "searchByType",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "all" } }, [
                                    _vm._v(" All "),
                                  ]),
                                  _c("option", { attrs: { value: "plant" } }, [
                                    _vm._v(" Plant "),
                                  ]),
                                  _c(
                                    "option",
                                    { attrs: { value: "customer" } },
                                    [_vm._v(" Customer ")]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "producer" } },
                                    [_vm._v(" Producer ")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "b-table",
                      {
                        ref: "table",
                        attrs: {
                          data: _vm.filteredDevices,
                          striped: "",
                          hoverable: "",
                          paginated: "",
                          "sticky-header": "",
                          height: "580",
                          checkable: "",
                          "checked-rows": _vm.checkedRows,
                          "is-row-checkable": (row) => row.registrationCode,
                        },
                        on: {
                          "update:checkedRows": function ($event) {
                            _vm.checkedRows = $event
                          },
                          "update:checked-rows": function ($event) {
                            _vm.checkedRows = $event
                          },
                        },
                      },
                      [
                        _c("b-table-column", {
                          attrs: {
                            field: "registrationCode",
                            label: "qrCode",
                            width: "80",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.registrationCode) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2599330977
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: { label: "Type" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "span",
                                      { class: _vm.typeClass(props.row) },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.calculateType(props.row)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            106521494
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: { label: "Detail", width: "230" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.typeDetail(props.row)) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2592455547
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: {
                            field: "serialNumber",
                            label: "Serial number",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(props.row.serialNumber) + " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            691988062
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: { field: "uuid", label: "UUID" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(" " + _vm._s(props.row.uuid) + " "),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2503915888
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: {
                            field: "registeredAt",
                            label: "Created at",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          new Date(
                                            props.row.registeredAt
                                          ).toLocaleString()
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1311632096
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: {
                            field: "lastSyncAt",
                            label: "Last sync",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          props.row.lastSyncAt
                                            ? new Date(
                                                props.row.lastSyncAt
                                              ).toLocaleString()
                                            : "Never"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3858212246
                          ),
                        }),
                        _c("b-table-column", {
                          attrs: { label: "Actions" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("b-button", {
                                      attrs: {
                                        "icon-left": "pen",
                                        size: "is-small",
                                        rounded: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showEditForm(props.row)
                                        },
                                      },
                                    }),
                                    props.row.isActivated !== null
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "is-small",
                                              rounded: "",
                                              disabled:
                                                props.row.isActivated === false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.resetDevice(
                                                  props.row.registrationCode
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon: "rotate",
                                                type: "is-primary",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "is-small",
                                          rounded: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteDevice(
                                              props.row.uuid
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            type: "is-danger",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1420732016
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-modal",
                {
                  attrs: { active: _vm.isEditing, scroll: "keep" },
                  on: {
                    "update:active": function ($event) {
                      _vm.isEditing = $event
                    },
                  },
                },
                [
                  _c("DeviceForm", {
                    attrs: {
                      "editable-device": _vm.editableDevice,
                      plants: _vm.plants,
                      customers: _vm.customers,
                      "is-submitting": _vm.isSubmitting,
                    },
                    on: { submit: _vm.submitChangePlant },
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: { active: _vm.addNewDevice, scroll: "keep" },
                  on: {
                    "update:active": function ($event) {
                      _vm.addNewDevice = $event
                    },
                  },
                },
                [
                  _c("NewDeviceForm", {
                    attrs: {
                      plants: _vm.plants,
                      customers: _vm.customers,
                      endusers: _vm.customersAndEndusers.endusers,
                    },
                    on: { "on-close": _vm.closeNewDeviceForm },
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: { active: _vm.batchAddNewDevice, scroll: "keep" },
                  on: {
                    "update:active": function ($event) {
                      _vm.batchAddNewDevice = $event
                    },
                  },
                },
                [
                  _c("BatchNewDeviceForm", {
                    attrs: { plants: _vm.plants, customers: _vm.customers },
                    on: { "on-close": _vm.closeNewDeviceForm },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }